import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { useNavigate } from 'react-router';
import { ROUTES } from '@constants/routes';
import { logNetRequest, scrollToTop } from '@utils/usefulFuncs';
import { Body5, Container, H5, Page } from '@ui';
import BackArrowButton from '@ui/buttons/BackArrowButton';
import { handle400Statuses, sendApiRequest } from '@services/api';
import RFPEditTool from '@containers/DigitalAnalyst/RFPEditTool';
import { Loading } from '@ui/Loading';
import { FlatButton } from '@ui/buttons';
import RFPCreateTool from '@containers/DigitalAnalyst/RFPCreateTool';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;
const Heading = styled.div`
  padding: 40px 0 4px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
// const tool = AI_TOOLS.QUERY;

const Error = () => {
  return <Body5>Something went wrong, please refresh and try again.</Body5>;
};

function RFPEditPage() {
  const navigate = useNavigate();

  const [data, setData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isCreatingNewRFP, setIsCreatingNewRFP] = React.useState(false);
  const [error, setError] = React.useState(null);

  const onGoBack = () => {
    if (isCreatingNewRFP) {
      setIsCreatingNewRFP(false);
    } else {
      navigate(ROUTES.home);
    }
  };
  const onCreateNewRFPClick = () => {
    setIsCreatingNewRFP(true);
  };

  React.useEffect(() => {
    scrollToTop();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    const url = '/v1/genai/rfp_responses';
    const { status, data, error } = await sendApiRequest('get', url);
    handle400Statuses(status);
    logNetRequest(status, data);
    if (status === 200) {
      setData(data.rfp_responses);
    } else {
      setError(error);
    }
    setIsLoading(false);
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  const onCreateComplete = (data) => {
    setIsCreatingNewRFP(false);
    fetchData();
  };

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <Page width={'1000px'}>
          <BackArrowButton onClick={onGoBack} />
          <Heading>
            <H5>{isCreatingNewRFP ? 'Create New RFP Response Item' : 'RFP Response Admin'}</H5>
            {!isCreatingNewRFP && <FlatButton onClick={onCreateNewRFPClick}>+ Create New RFP Response Item</FlatButton>}
          </Heading>
          {!isCreatingNewRFP && (
            <Container top={0} bottom={24}>
              <Body5>Save changes for each item individually at the bottom of each RFP Response Item section.</Body5>
            </Container>
          )}
          <Container top={24}>
            {isLoading ? (
              <Loading />
            ) : error ? (
              <Error />
            ) : isCreatingNewRFP ? (
              <RFPCreateTool onCreateComplete={onCreateComplete} />
            ) : (
              <RFPEditTool rfpResponses={data} />
            )}
          </Container>
        </Page>
      </Body>
    </PageWrapper>
  );
}

export default RFPEditPage;
